module.exports = __webpack_public_path__ + "img/background4.73cacbfd.jpg";